import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import { productService } from '../../../services/productService';

const ProductModal = ({ product, onClose, onSaveSuccess }) => {
  const [formData, setFormData] = useState({ nombre: '', activo: true });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (product) {
      setFormData({ nombre: product?.nombre || '', activo: product?.activo ?? true });
    }
  }, [product]);

  const handleSubmit = async (e) => {
    e?.preventDefault();
    if (!formData?.nombre?.trim()) {
      setError('El nombre del producto es obligatorio');
      return;
    }
    try {
      setLoading(true);
      setError(null);
      if (product) {
        await productService?.update(product?.id, formData);
      } else {
        await productService?.create(formData);
      }
      onSaveSuccess();
    } catch (err) {
      console.error('Error saving product:', err);
      setError(err?.message || 'Error al guardar el producto');
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setError(null);
  };

  return (
    <div className="fixed inset-0 bg-black/70 flex items-center justify-center z-50 p-4">
      <div className="bg-[#1A1A1A] border border-white/10 rounded-xl shadow-2xl w-full max-w-md font-oranienbaum">
        {/* Header */}
        <div className="flex justify-between items-center px-6 py-4 border-b border-white/8">
          <h2 className="text-base font-bold font-oranienbaum text-[#D6EF4E]">
            {product ? 'Editar Producto' : 'Nuevo Producto'}
          </h2>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-white/40 hover:text-white hover:bg-white/8 transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          {error && (
            <div className="bg-red-500/10 border border-red-500/30 text-red-400 px-4 py-3 rounded-lg text-sm font-oranienbaum">
              {error}
            </div>
          )}

          <div>
            <label className="block text-xs font-oranienbaum text-white/50 mb-2">
              Nombre del Producto <span className="text-[#E05252]">*</span>
            </label>
            <input
              type="text"
              value={formData?.nombre}
              onChange={(e) => handleChange('nombre', e?.target?.value)}
              placeholder="Ingrese el nombre del producto"
              required
              className="w-full px-3 py-2.5 bg-[#111111] border border-white/10 rounded-lg text-white text-sm font-oranienbaum placeholder-white/25 focus:outline-none focus:border-[#D6EF4E]/50 transition-colors"
            />
          </div>

          <div className="flex items-center gap-3">
            <div
              onClick={() => handleChange('activo', !formData?.activo)}
              className={`relative w-10 h-5 rounded-full cursor-pointer transition-colors ${
                formData?.activo ? 'bg-[#3A7F6B]' : 'bg-white/15'
              }`}
            >
              <div
                className={`absolute top-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform ${
                  formData?.activo ? 'translate-x-5' : 'translate-x-0.5'
                }`}
              />
            </div>
            <label
              onClick={() => handleChange('activo', !formData?.activo)}
              className="text-sm font-oranienbaum text-white/70 cursor-pointer"
            >
              Producto Activo
            </label>
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 bg-white/5 border border-white/10 rounded-lg text-white/60 text-sm font-oranienbaum hover:bg-white/10 hover:text-white transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="submit"
              disabled={loading}
              className="px-4 py-2 bg-[#D6EF4E] text-[#111111] rounded-lg text-sm font-oranienbaum font-bold hover:bg-[#c8e040] transition-colors disabled:opacity-50"
            >
              {loading ? 'Guardando...' : product ? 'Actualizar' : 'Crear Producto'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ProductModal;